import React from 'react';
import { InsightSection } from 'store/state/insightsContext';
import WidgetCollapsedWrapper from 'components/widget/common/widget-collapsed-wrapper';
import { ExpandedWidgetContent } from 'components/widget/common/styled';
import { DemographicsWidget } from 'components/widget/demographics';
import { NeighborsDynamicContentProps } from '../common/widget-collapsed-wrapper/dynamic-content/neighbors';
import { InsightType } from 'utils/entities';

interface NeighborsWidgetProps {
  dynamicContentText?: string;
}

export const NeighborsWidget: React.FC<NeighborsWidgetProps> = ({ dynamicContentText }) => {
  const dynamicContentData: NeighborsDynamicContentProps = { text: dynamicContentText };
  return (
    <WidgetCollapsedWrapper
      styleType={InsightType.Livability}
      targetId={InsightSection.Neighbors}
      dynamicContentData={dynamicContentData}
    >
      <ExpandedWidgetContent>
        <DemographicsWidget />
      </ExpandedWidgetContent>
    </WidgetCollapsedWrapper>
  );
};
